<template>
  <div>
    <!--        <breadcrumb :routerList="[{to:'/establish/contractlist',title:'返利管理'},{title:'返利计算'}]"/>-->
    <Breadtabsheader/>
    <div class="h-content">
      <!--查询表单-->
      <div class="h-piece">
        <div class="h-formBox">
          <!-- <div class="h-pieceTitle2" style="margin-bottom:0.2rem">
              <h1>返利</h1>
          </div> -->
          <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder" ref="form">
            <div class="h-thirdColumn w-newColumn">
              <el-form-item label="客户名称" prop="agentNameLike" style="width: 40%;">
                <el-input v-model="q.agentNameLike" placeholder="多客户模糊查询请用空格或分号分隔"></el-input>
              </el-form-item>
              <el-form-item label="客户编码" prop="agentCodeLike" style="width: 40%;">
                <el-input v-model="q.agentCodeLike" placeholder="多客户模糊查询请用空格或分号分隔"></el-input>
              </el-form-item>
              <el-form-item label="类型" prop="styles">
                <el-select v-model="q.type" placeholder="请选择">
                  <el-option
                      v-for="item in fljsstyle"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="时间" class="nianboxs">
                <el-date-picker
                    style="width: 100%;"
                    v-model="q.date"
                    :clearable="true"
                    type="month"
                    value-format="yyyy-MM"
                    placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
            </div>
            <el-collapse-transition>
              <div v-show="isScreen">
                <div class="h-thirdColumn w-newColumn">
                  <el-form-item label="经销商类型" prop="agentType">
                    <brselect category="fl_agent_type" :v="q.agentType" v-model="q.agentType" :clearable="true"/>
                  </el-form-item>
                  <el-form-item label="链群" prop="contractId">
                    <brselect category="fl_contract_type_main" :v="q.contractId" v-model="q.contractId" :clearable="true"/>
                  </el-form-item>
                  <el-form-item label="返利公司" prop="rebateChainGroup">
                    <el-select v-model="q.rebateChainGroup" placeholder="请选择">
                      <el-option
                          v-for="item in vkorgData"
                          :key="item.productName"
                          :label="item.productType"
                          :value="item.productName">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
            </el-collapse-transition>
            <div class="l-screenBox">
              <div class="l-screen" @click="collapseChange">
                <img :src="isScreen?closeScreen:drawScreen" alt="">
                <div class="l-screenText">{{ isScreen ? "收起" : "展开" }}</div>
              </div>
              <div class="l-retrieval">
                <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                <el-button class="h-btn h-formBtn h-bgwhite" @click="qingkong">重置</el-button>
                <el-button class="h-btn h-formBtn h-bggreen" @click="gatherFlShujuBase" v-auth="'jsfl_salesupdate'">数据生成</el-button>
                <el-button class="h-btn h-formBtn h-bggreen" @click="jisuanFanli" v-auth="'jsfl_fanlijisuan'">计算返利</el-button>
<!--                <el-button class="h-btn h-formBtn h-bggreen" @click="jisuanFanlihh" v-auth="'jsfl_fanlijisuan'">厚宏计算返利</el-button>-->
              </div>
            </div>
          </el-form>

        </div>
      </div>
      <div class="h-table h-mrt30">
        <div class="h-tableB h-mrt30">
          <el-table @selection-change="handleSelectionChange"
                    ref="ddtable"
                    :data="tableData"
                    stripe
                    style="width: 100%"
                    :border="true"
                    max-height="430"
          >
            <el-table-column
                type="selection"
                width="45"
                fixed
            >
            </el-table-column>
            <el-table-column
                type="index"
                label="#"
                fixed
                width="40">
            </el-table-column>
            <el-table-column
                prop="year"
                :show-overflow-tooltip="true"
                width="80"
                label="年份"
            >
            </el-table-column>
            <el-table-column
                prop="month"
                :show-overflow-tooltip="true"
                width="80"
                label="月份"
            >
            </el-table-column>
            <el-table-column
                prop="areaCode"
                :show-overflow-tooltip="true"
                width="80"
                label="区域"
            >
              <template slot-scope="scope">
                {{scope.row.areaCode|dictname('YLRegion')}}
              </template>
            </el-table-column>
            <el-table-column
                prop="agentType"
                :show-overflow-tooltip="true"
                width="100"
                label="经销商类型"
            >
              <template slot-scope="scope">
                {{scope.row.agentType|dictname('fl_agent_type')}}
              </template>
            </el-table-column>
            <el-table-column
                prop="rebateChainGroup"
                :show-overflow-tooltip="true"
                width="100"
                label="产业"
            >
              <template slot-scope="scope">
                {{scope.row.rebateChainGroup|dictname('fl_26_cy_all')}}
              </template>
            </el-table-column>
            <el-table-column
                prop="agentCode"
                :show-overflow-tooltip="true"
                width="120"
                label="客户编码"
                fixed
            >
            </el-table-column>
            <el-table-column
                prop="agentName"
                :show-overflow-tooltip="true"
                min-width="180"
                label="客户名称"
                fixed
            >
              <template slot-scope="scope">
                <div style="text-align: left;">
                  {{scope.row.agentName}}
                </div>
              </template>
            </el-table-column>
            <el-table-column
                prop="contractId"
                :show-overflow-tooltip="true"
                width="100"
                label="链群"
            >
              <template slot-scope="scope">
                {{scope.row.contractId|dictname('fl_contract_type_main')}}
              </template>
            </el-table-column>
            <el-table-column
                prop="tongqi"
                :show-overflow-tooltip="true"
                width="80"
                label="同期"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{scope.row.tongqi}}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="goal"
                :show-overflow-tooltip="true"
                width="80"
                label="目标"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{scope.row.goal}}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="salesVolume"
                :show-overflow-tooltip="true"
                width="80"
                label="销额"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{scope.row.salesVolume}}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="rebateBase"
                :show-overflow-tooltip="true"
                width="80"
                label="基数"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{scope.row.rebateBase}}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="rebateCoefficient"
                :show-overflow-tooltip="true"
                width="80"
                label="系数"
            >
            </el-table-column>
            <el-table-column
                prop="completionRate"
                :show-overflow-tooltip="true"
                width="80"
                label="完成率"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{(Number(scope.row.completionRate*100).toFixed(2)) + '%'}}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="realRebateAmount"
                :show-overflow-tooltip="true"
                width="90"
                label="基础返利"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{scope.row.realRebateAmount}}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="newRebateAmount"
                :show-overflow-tooltip="true"
                width="90"
                label="奖励金额"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{scope.row.newRebateAmount}}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="jiduMonthRebamount"
                :show-overflow-tooltip="true"
                width="90"
                label="分销奖励"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{scope.row.jiduMonthRebamount}}</div>
              </template>
            </el-table-column>
            <el-table-column
                prop="rebateAmount"
                :show-overflow-tooltip="true"
                width="90"
                label="最终返利"
            >
              <template slot-scope="scope">
                <div style="text-align: right;">{{scope.row.rebateAmount}}</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!--展示表格-->
      <div class="h-table h-mrt30">
        <div class="h-tableB h-mrt30">
          <div class="h-tableBL">
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                       @click="exportExcel" v-auth="'fanli_daochu'">批量导出
            </el-button>
<!--            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                       @click="hhexportExcel" v-auth="'fanli_daochu'">厚宏批量导出
            </el-button>-->
            <el-button class="h-btn h-formBtn h-bgblueQ"
                       @click="chuanSAP" v-auth="'fl_chuanSAP'">返利传SAP
            </el-button>
<!--            <el-button class="h-btn h-formBtn h-bgblueQ"
                       @click="hhchuanSAP" v-auth="'fl_chuanSAP'">厚宏传SAP
            </el-button>-->
          </div>
          <div class="h-pagination2">
            <pagination :page="q" @query="handleFilter"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ss from '../../../api/SystemService'
import updownfile from '../../../utils/updownfile'
import uploaddownexcel from "../../../components/uploaddown/uploadBanchExcel"

export default {
  components: {
    uploaddownexcel,
  },
  data() {
    return {
      // 展开折叠筛选
      isScreen: false,
      closeScreen: require("@/assets/images/pimg/closeallic.png"),
      drawScreen: require("@/assets/images/pimg/dobleArr.png"),
      fljsstyle: [
        {
          value: 1,
          label: '月度'
        },
        {
          value: 2,
          label: '季度'
        },
        {
          value: 3,
          label: '半年度'
        },
        {
          value: 4,
          label: '年度'
        },
      ],
      q: {
        contractId:'',
        agentType:'',
        type:'',
        date: this.$util.riQi(new Date(new Date().getFullYear(), new Date().getMonth())),
        agentNameLike: '',
        agentCodeLike:'',
        rebateChainGroup: this.getVkorgPermission(),
        pageSize: 10,
        pageNo: 1,
        total: 0,
      },
      //表格
      multipleSelection: [],
      //table列表
      tableData: [],
      //table列表
      allVkorgData: [
        {
          productName: 'ct',
          productType: '总部'
        }, {
          productName: 'hh',
          productType: '厚宏'
        }, {
          productName: 'ydg',
          productType: '海盛杰'
        }
      ],
      vkorgData: [],
    }
  },
  created() {
    this.getVkorgPermission();
    this.query();
  },
  beforeRouteLeave(to, from, next) {
    from.meta.keepAlive = false;
    next();
  },
  methods: {
    // 展开折叠
    collapseChange() {
      this.isScreen = !this.isScreen;
    },
    //查询
    query() {
      this.handleFilter();
    },
    handleFilter() {
      ss.fanli.pagelist(this.q).then(rd => {
        this.q.total = rd.total;
        this.tableData = rd.records;
      });
    },
    //重置
    qingkong() {
      this.q.contractId ='';
      this.q.agentType ='';
      this.q.type ='';
      this.q.date = this.$util.riQi(new Date(new Date().getFullYear(), new Date().getMonth()));
      this.q.agentNameLike ='';
      this.q.agentCodeLike ='';
      this.q.rebateChainGroup =this.getVkorgPermission();
      this.query();
    },
    //传SAP
    chuanSAP() {
      var idlist = [];
      this.multipleSelection.forEach(element => {
        idlist.push(element.id);
      });
      this.$msg.confirm("确认传SAP?", () => {
        this.q.idlist=idlist;
        ss.fanli.chuanruSAP({...this.q, isHouhong: false}).then(rd => {
          console.log(id + "11111111111")
          this.$msg.msgs(rd.msg);
          this.query();
        });
      });

    },
    hhchuanSAP(){
      var idlist = [];
      this.multipleSelection.forEach(element => {
        idlist.push(element.id);
      });
      this.$msg.confirm("确认传厚宏SAP?", () => {
        this.q.idlist=idlist;
        ss.fanli.chuanruSAP({...this.q, isHouhong: true}).then(rd => {
          console.log(id + "11111111111")
          this.$msg.msgs(rd.msg);
          this.query();
        });
      });
    },
    gatherFlShujuBase(){
      ss.fanli.gatherFlShujuBase(this.q).then(rd => {
        console.log(rd, "重新生成数据");
        ss.fanli.pagelist(this.q).then(rd => {
          console.log(rd, "AAAAAA");
          this.q.total = rd.total;
          this.tableData = rd.records;
        });
      });
    },
    //计算返利厚宏
    jisuanFanlihh(){
      this.$msg.confirm("计算时间大约10-20分钟，请耐心等待！", () => {
        ss.fanli.fanlijisuan(this.q).then(rd => {
          console.log(rd, "BBBBBBAAAAAA");
          ss.fanli.pagelist(this.q).then(rd => {
            console.log(rd, "AAAAAA");
            this.q.total = rd.total;
            this.tableData = rd.records;
          });
        });
      });
    },
    //计算返利
    jisuanFanli() {
      this.$msg.confirm("计算时间大约10-20分钟，请耐心等待！", () => {
        ss.fanli.fanlijisuan({...this.q}).then(rd => {
          console.log(rd, "BBBBBBAAAAAA");
          ss.fanli.pagelist(this.q).then(rd => {
            console.log(rd, "AAAAAA");
            this.q.total = rd.total;
            this.tableData = rd.records;
          });
        });
      });
    },
    //勾选
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection, "勾选内容")
    },
    //返利批量导出
    exportExcel() {
      var idlist = [];
      this.multipleSelection.forEach(element => {
        idlist.push(element.id);
      });
      if (idlist.length != 0) {
        updownfile.down("/api/swyl/v1/demo/viewFlAgentTarget/downloadExcelId", idlist, "post", 'data');
      } else {
        updownfile.down("/api/swyl/v1/demo/viewFlAgentTarget/downloadExcelEntity", this.q, "post");
      }
    },
    //付款公司筛选项权限
    getVkorgPermission() {
      var type = 4;
      ss.fanli.getPermissions(type).then(rd => {
        console.log(rd, "AAAAAA");
        if(rd.obj){
          this.vkorgData = rd.obj;
        }else{
          this.vkorgData = this.allVkorgData;
        }
        if (this.vkorgData && this.vkorgData.length > 0) {
          this.$set(this.q, 'rebateChainGroup', this.vkorgData[0].productName);
        }
      });
    },
  }
}
</script>
